<template>
  <Modal class="modal-sm modal--logout"
         :loading="loading"
         header-disabled
         footer-disabled
  >
    <template #default="{close}">
      <div class="logout">
        <div class="logout__header">
          {{ $t('front.logout') }}
        </div>
        <div class="logout__body flex-column">
          {{ $t('front.logout_message') }}

          <template v-if="prevUser">
            <div class="w-100 d-flex align-items-center flex-column justify-content-center mt-5">
              <span class="text-truncate">{{ prevUser.email }}</span>
              <Button @click="logout()" class="btn-primary btn-bordered btn-sm mt-1">
                {{ $t('front.switch_account') }}
              </Button>
            </div>
          </template>
        </div>
        <div class="logout__footer">
          <Button class="btn-primary btn-bordered btn-lg"
                  @click="close"
          >
            {{ $t('global.cancel') }}
          </Button>

          <Button @click="logout(true)" class="btn-primary btn-lg">
            {{ $t('front.logout') }}
          </Button>
        </div>
      </div>
    </template>
  </Modal>
</template>
<script setup>
import Modal from "@/js/Components/Modal/Modal.vue";
import Button from "@/js/Elements/Button.vue";
import axios from "axios";
import {useRouter} from "vue-router";
import {computed, ref} from "vue";
import {useStore} from "vuex";
import {useLoader} from "@/js/Plugins/Loader.js";

const router = useRouter();
const store = useStore();
const loader = useLoader();
const prevUser = computed(() => store.getters['auth/prev']);

function logout(force) {
  loader.show();
  window.location.href = `/logout${force ? '?force=1' : ''}`;
}
</script>
<style lang="scss">
.modal--logout .modal-dialog {
  top: 50%;
  transform: translateY(-100%);
}
</style>
<style lang="scss" scoped>
@import "@/css/functions";
@import "@/css/variables";

.logout {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &__header,
  &__footer,
  &__body {
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__header {
    font-size: fontSize(1);
    font-weight: $font-weight-semibold;
  }

  &__body {
    color: themeColor('neutral-700');
    margin-top: spacing(2);
  }

  &__footer {
    margin-top: spacing(6);
    gap: spacing(3);

    .btn {
      width: 100%;
    }
  }
}
</style>